import { render } from "./Contacts.vue?vue&type=template&id=51694f8d&scoped=true&lang=pug"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=51694f8d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-51694f8d"

export default script